import styled from 'styled-components';

const FullPageFormContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: fit-content;
  padding: 40px 0px;
  margin-top: -1vh;
`;

export default FullPageFormContainer;
